import React, { useContext } from 'react';

export const FiltersContext = React.createContext();

export const useFiltersContext = () => useContext(FiltersContext);

const FiltersProvider = ({ children }) => {
  const [filters, setFilters] = React.useState({
    severity: ['All'],
    result: ['All'],
    category: ['All']
  });

  const [mainPageFilters, setMainPageFilters] = React.useState({
    pageType: [],
    region: [],
    site: [],
    server: [],
    requester: [],
    calendar: [null, null]
  });

  return (
    <FiltersContext.Provider value={{ filters, setFilters, mainPageFilters, setMainPageFilters }}>
      {children}
    </FiltersContext.Provider>
  );
};

export default FiltersProvider;
